import Icon from 'components/Icon';
import Seo from 'components/Seo';

export default function TermsPage() {
  return (
    <>
    <Seo title="Terms of Service" description="The terms for using Devlayar free online tools." path="/terms" />
    <div className="static-page">
      <div className="container">
        <div className="static-hero">
          <div className="static-hero-icon"><Icon name="shield" size={26} /></div>
          <h1>Terms of Service</h1>
          <p>Last updated: 2026</p>
        </div>

        <div className="static-body">
          <p>Welcome to Devlayar. By accessing or using our website and tools, you agree to these Terms of Service. Please read them carefully.</p>

          <h2>Use of Our Tools</h2>
          <p>Devlayar provides free online tools for your personal and professional use. You agree to use these tools only for lawful purposes and not to misuse them or attempt to disrupt the service.</p>

          <h2>No Warranty</h2>
          <p>Our tools are provided "as is" and "as available." While we work hard to keep them accurate and reliable, we do not guarantee that every tool will be error-free or available at all times. Always keep your own backup of important files.</p>

          <h2>Your Content</h2>
          <p>You retain all rights to the files and content you use with our tools. Since most tools run in your browser, your content stays on your device. You are responsible for ensuring you have the right to use any content you process.</p>

          <h2>Limitation of Liability</h2>
          <p>Devlayar and Ethoss Technologies are not liable for any loss or damage arising from your use of the tools, including loss of data. Use the tools at your own discretion.</p>

          <h2>Intellectual Property</h2>
          <p>The Devlayar name, design, and original content are the property of Ethoss Technologies and may not be copied or reused without permission.</p>

          <h2>Changes to These Terms</h2>
          <p>We may update these Terms from time to time. Continued use of the site after changes means you accept the updated Terms.</p>

          <h2>Contact</h2>
          <p>Questions about these Terms? Reach us via our <a href="/contact">Contact page</a> or email support@devlayar.com.</p>
        </div>
      </div>
    </div>
  </>
  );
}
